import {Component, OnInit} from '@angular/core';
import {
    MxDynamicFormService,
    MxFormCustomizerEvent, MxFormErrorMessageService,
    OnBoFormBeforeSubmit,
    OnBoFormReady,
    UiDataObj,
} from 'mx-core';
import {PrlFinanceService} from '../../../../services/prl-finance.service';
import {combineLatestAll, of, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {PrlTranslateService} from '../../../../../../shared/services/prl-translate.service';
import {FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {MatDialogRef} from '@angular/material/dialog';


@Component({
    selector: 'prl-new-payment-account',
    standalone: false,
    templateUrl: './prl-new-payment-account.component.html'
})
export class PrlNewPaymentAccountComponent implements OnInit, OnBoFormReady, OnBoFormBeforeSubmit {
    private _destroy$$: Subject<null> = new Subject<null>();
    private form: FormGroup;
    private paymentMethods: any[] = [];
    private lastEnabledRawValue: { [key: string]: any } = {};

    constructor(private financeService: PrlFinanceService,
                private dynamicFormService: MxDynamicFormService,
                private readonly translateService: PrlTranslateService,
                private readonly router: Router,
                private errorService: MxFormErrorMessageService,
                private dialogRef: MatDialogRef<PrlNewPaymentAccountComponent>
    )
    {}

    ngOnInit(): void {
        this.financeService.getPaymentMethods()
            .pipe(takeUntil(this._destroy$$))
            .subscribe(methods => {
                this.paymentMethods = methods;
            });
    }

    onCustomize(event: MxFormCustomizerEvent): void {
        event.customizeBoFormConfig({title: 'label.finance.payment.account.create.new'})
            .customizeFormMode('new');
        of(
            this.dynamicFormService.getUIData('com.playtech.mexos.contract.finance.NewPaymentAccountPrlObj'),
        ).pipe(takeUntil(this._destroy$$), combineLatestAll())
            .subscribe(([uiData]) => {
                const fieldSource = uiData as UiDataObj;
                const paymentMethodField = uiData.fieldsData.find(f => f.name === 'paymentMethod');
                if (paymentMethodField && this.paymentMethods.length > 0) {
                    (paymentMethodField as any).options = this.paymentMethods.map(pm => ({
                        key: pm.name,
                        value: pm.name
                    }));
                }
                event.fieldsData.next({
                    objectMetaSource: fieldSource,
                    initialData: {}
                });
            });
        event.customizeActions({
                submit: {
                    text: ()=> this.translateService.getTranslatedLabel('label.submit'),
                    visible: true
                },
                cancel: {
                    text: ()=> this.translateService.getTranslatedLabel('label.cancel'),
                    visible: true
                }
            })
            .customizeProps({
                addPrefixToTitle: false,
                submitFunction: (form: FormGroup): void => {
                    const payload = {...form.getRawValue(), ...this.lastEnabledRawValue};
                    this.financeService.savePaymentAccount(payload)
                        .subscribe({
                            next: res => {
                                this.dialogRef.close();
                            },
                            error: err => {
                                if (err?.status === 400 && err.error?.fieldErrors) {
                                    this.errorService.setServerErrors(err.error, form);
                                }
                                form.enable();
                            }
                        });
                },
                showNavigation: false,
                customNavigation: {
                    onCancel: () => {
                        this.dialogRef.close();
                    }
                }
            });

        event.addCustomizer(this);
    }

    boOnFormReady(form: FormGroup): void {
        form.setAsyncValidators(this.errorService.asyncValidator(this.financeService));
        this.form = form;
        form.valueChanges
            .pipe(takeUntil(this._destroy$$))
            .subscribe(() => {
                if (!form.enabled) {
                    return;
                }
                const raw = form.getRawValue();
                Object.keys(raw).forEach(key => {
                    const value = raw[key];
                    if (value !== null && value !== undefined && value !== '') {
                        this.lastEnabledRawValue[key] = value;
                    }
                });
            });
    }

    boOnBeforeSubmit(form: FormGroup): void {
        Object.entries(this.lastEnabledRawValue).forEach(([name, value]) => {
            const control = form.get(name);
            if (control && (control.value === null || control.value === undefined || control.value === '')) {
                control.setValue(value, {emitEvent: false});
            }
        });
    }
}